export default __webpack_public_path__ + "static/your_fault-7cc589492327869ae64805cd9b6e9b3f.mp4";